import { useState } from 'react'

const EntryForm = ({ addEntry }) => {
   const [teamName, setTeamName] = useState('')
   const [r1_name, setR1_name] = useState('')
   const [r2_name, setR2_name] = useState('')
   const [r3_name, setR3_name] = useState('')
   const [r1_born, setR1_born] = useState(0)
   const [r2_born, setR2_born] = useState(0)
   const [r3_born, setR3_born] = useState(0)
   const [r1_card, setR1_card] = useState(0)
   const [r2_card, setR2_card] = useState(0)
   const [r3_card, setR3_card] = useState(0)
   const [r1_gender, setR1_gender] = useState('F')
   const [r2_gender, setR2_gender] = useState('F')
   const [r3_gender, setR3_gender] = useState('F')
   const [r1_beginner, setR1_beginner] = useState(false)
   const [r2_beginner, setR2_beginner] = useState(false)
   const [r3_beginner, setR3_beginner] = useState(false)


  const addTeam = (event) => {
    event.preventDefault()
    addEntry({
      team_name: teamName,
      r1: {
        name: r1_name,
        born: r1_born,
        card: r1_card,
        gender: r1_gender,
        beginner: r1_beginner
      }, 
      r2: {
        name: r2_name,
        born: r2_born,
        card: r2_card,
        gender: r2_gender,
        beginner: r2_beginner
      }, r3: {
        name: r3_name,
        born: r3_born,
        card: r3_card,
        gender: r3_gender,
        beginner: r3_beginner
      }
    })

    setTeamName('')
    setR1_name('')
    setR2_name('')
    setR3_name('')
    setR1_born(0)
    setR2_born(0)
    setR3_born(0)
    setR1_card(0)
    setR2_card(0)
    setR3_card(0)
    setR1_gender('F')
    setR2_gender('F')
    setR3_gender('F')
    setR1_beginner(false)
    setR2_beginner(false)
    setR3_beginner(false)
  }

  return (
    <div>
      <h2>Ilmoita joukkue Kyläviestiin</h2>

      <form onSubmit={addTeam}>
      <p><b>Joukkueen nimi:</b></p>
      <input
        value={teamName}
        onChange={event => setTeamName(event.target.value)}
      />
      <p></p>
      <table>
        <tr>
            <th>Osuus</th>
            <th>Nimi</th>
            <th>Syntymävuosi</th>
            <th>EMIT-kortti</th>
            <th>Sukupuoli</th>
            <th>Aloittelija</th>
        </tr>
        <tr>
            <td>Osuus 1</td>
            <td>
                <input
                value={r1_name}
                onChange={event => setR1_name(event.target.value)}
                />
            </td>
            <td>
                <input
                value={r1_born}
                onChange={event => setR1_born(event.target.value)}
                />
            </td>
            <td>
                <input
                value={r1_card}
                onChange={event => setR1_card(event.target.value)}
                />
            </td>
            <td>
              <select onChange={event => setR1_gender(event.target.value)}>
                <option value="F" selected>Nainen</option>
                <option value="M">Mies</option>
              </select>
            </td>
            <td>
              <input type="checkbox" onChange={event => setR1_beginner(event.target.checked)}></input>
            </td>
        </tr>
        <tr>
            <td>Osuus 2</td>
            <td>
                <input
                value={r2_name}
                onChange={event => setR2_name(event.target.value)}
                />
            </td>
            <td>
                <input
                value={r2_born}
                onChange={event => setR2_born(event.target.value)}
                />
            </td>
            <td>
                <input
                value={r2_card}
                onChange={event => setR2_card(event.target.value)}
                />
            </td>
            <td>
              <select onChange={event => setR2_gender(event.target.value)}>
                <option value="F" selected>Nainen</option>
                <option value="M">Mies</option>
              </select>
            </td>
            <td>
              <input type="checkbox" onChange={event => setR2_beginner(event.target.checked)}></input>
            </td>
        </tr>
        <tr>
            <td>Osuus 3</td>
            <td>
                <input
                value={r3_name}
                onChange={event => setR3_name(event.target.value)}
                />
            </td>
            <td>
                <input
                value={r3_born}
                onChange={event => setR3_born(event.target.value)}
                />
            </td>
            <td>
                <input
                value={r3_card}
                onChange={event => setR3_card(event.target.value)}
                />
            </td>
            <td>
              <select onChange={event => setR3_gender(event.target.value)}>
                <option value="F" selected>Nainen</option>
                <option value="M">Mies</option>
              </select>
            </td>
            <td>
              <input type="checkbox" onChange={event => setR3_beginner(event.target.checked)}></input>
            </td>
        </tr>
    </table>
        
        <button type="submit">Ilmoita joukkue</button>
      </form>
    </div>
  )
}

export default EntryForm